import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { OrdineVendita } from '../../_models/OrdineVendita';
import { CampoUtenteDef } from '../../_models/CampoUtenteDef';
import {
  getStatoConsegnaClass,
  getStatoConsegnaLabel,
  getStatoOrdineClass,
  getStatoOrdineLabel,
} from '../../_helpers/stato-ordine-vendita.helper';
import {
  OvListColumn,
  formatOvCellValue,
  resolveOvColumn,
} from '../../_models/ordine-vendita-list-columns';

// Componente di presentazione condiviso (feature 061): rende le sole celle desktop
// "Excel-like" di un OrdineVendita iterando su visibleColumns. Estratto dal ramo desktop
// di OrdineVenditaRowComponent per essere riusato sia dagli Ordini Clienti sia
// dall'elenco attività del Dettaglio Pianifica (fonte unica di verità, FR-013).
// Non include il wrapper bordo/azioni né la variante mobile: quelli restano nei contenitori.
@Component({
  selector: 'app-ordine-vendita-cells',
  templateUrl: './ordine-vendita-cells.component.html',
  // `display: contents`: l'host non deve diventare una singola cella di griglia — le sue
  // <div> colonna devono partecipare direttamente alla CSS Grid del contenitore (riga OdV
  // o riga attività), come faceva il precedente <ng-container *ngFor> inline.
  styles: [':host { display: contents; }'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrdineVenditaCellsComponent {
  @Input() ordine!: OrdineVendita;
  @Input() visibleColumns: readonly string[] = [];
  // Gating del badge "Pianificato" nella cella RifOrdine: ridondante nel contesto pianifica.
  @Input() showPianificatoBadge = true;
  // Feature 064 — definizioni Campi Utente attive dell'org, per renderizzare le colonne
  // dinamiche `Cu_<codice>` dal JSON `campiUtente`. Vuoto ⇒ tali colonne rese come "-".
  @Input() campiUtenteDefinizioni: CampoUtenteDef[] = [];

  @Output() ordineSelected = new EventEmitter<OrdineVendita>();

  readonly getStatoLabel = getStatoOrdineLabel;
  readonly getStatoClass = getStatoOrdineClass;
  readonly getConsegnaLabel = getStatoConsegnaLabel;
  readonly getConsegnaClass = getStatoConsegnaClass;

  // Feature 064 — render generico (`*ngSwitchDefault`) per le colonne senza case dedicato.
  // resolveOvColumn risolve anche le colonne dinamiche `Cu_<codice>` (assenti dal registry
  // statico) a partire dalle definizioni Campi Utente, altrimenti i Campi Utente renderebbero "-".
  getMeta(col: string): OvListColumn | undefined {
    return resolveOvColumn(col, this.campiUtenteDefinizioni);
  }

  formatCell(col: string): string {
    const meta = resolveOvColumn(col, this.campiUtenteDefinizioni);
    return meta ? formatOvCellValue(this.ordine, meta, this.campiUtenteDefinizioni) : '-';
  }
}
